import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const ax = axios.create({ baseURL: BASE_URL });

export const fetch = async (path: string) => {
  const localToken: any = localStorage.getItem("auth:token");
  ax.defaults.headers.common["Authorization"] = `Bearer ${localToken}`;
  const result = await ax.get(`${path}`).then(({ data }) => {
    return data;
  });
  return result;
};

export const post = async (path: string, data: any) => {
  const localToken: any = localStorage.getItem("auth:token");
  ax.defaults.headers.common["Authorization"] = `Bearer ${localToken}`;
  const result = await ax.post(`${path}`, data).then(({ data }) => {
    return data;
  });
  return result;
};

export const patch = async (path: string, data?: any) => {
  const localToken: any = localStorage.getItem("auth:token");
  ax.defaults.headers.common["Authorization"] = `Bearer ${localToken}`;
  const result = await ax.patch(`${path}`, data).then(({ data }) => {
    return data;
  });
  return result;
};

export const deleteRequest = async (path: string, data?: any) => {
  const localToken: any = localStorage.getItem("auth:token");
  ax.defaults.headers.common["Authorization"] = `Bearer ${localToken}`;
  const result = await ax.delete(`${path}`, data).then(({ data }) => {
    return data;
  });
  return result;
};
